/*
       public int Attb_AttributeID { get; set; }
        public int Attb_PropertyIdentity { get; set; }
        public string Attb_AttributeCodeID { get; set; }
        public string Attb_LocationID { get; set; }
        public string Attb_ConditionIndicatorIdentity { get; set; }
        public Nullable<System.DateTime> Attb_DateLastMaintained { get; set; }
        public Nullable<System.DateTime> Attb_DateLastReplaced { get; set; }
        public Nullable<System.DateTime> Attb_MaintenanceDueDate { get; set; }
        public Nullable<int> Attb_Quantity { get; set; }
        public string Attb_Status { get; set; }
        public string Attb_InspectionCetificateNo { get; set; }
        public string Attb_ResponsibleClient { get; set; }
        public string Attb_PreferredInspectionContractor { get; set; }
        public string Attb_PreferredContractorMaintenance { get; set; }
        public string Attb_AssetNumber { get; set; }
        public string Attb_Manufacturer { get; set; }
        public string Attb_Model { get; set; }
        public string Attb_Description { get; set; }
        public bool Attb_TenantsResponsibility { get; set; }
        public Nullable<System.DateTime> Attb_WarrantyExpiryDate { get; set; }
        public Nullable<decimal> Attb_ManfEstimatedCost { get; set; }
        public byte[] UpdatedOn { get; set; }
        public bool Attb_MaintainedFlag { get; set; }
        public string Attb_SerialNumber { get; set; }
        public bool Attb_PassedInspection { get; set; }
        public bool Attb_RepairRequired { get; set; }
        public bool Attb_ReplacementRequired { get; set; }
        public string Attb_AttributeReasonCodeID { get; set; }
        public Nullable<System.DateTime> Attb_ReplacementDueDate { get; set; }
        public Nullable<System.DateTime> Attb_InspectionDueDate { get; set; }
        public Nullable<System.DateTime> Attb_DateLastInspected { get; set; }
        public decimal Attb_Easting { get; set; }
        public decimal Attb_Northing { get; set; }
        public decimal Attb_Radius { get; set; }
        public bool Attb_Export { get; set; }
 */

export class PropPropertyAttribute {
  Attb_AttributeID: number;
  Attb_PropertyIdentity: number;
  Attb_AttributeCodeID: string;
}
